module.exports = __webpack_public_path__ + "img/img13.ab4b46ec.svg";